import { render } from "./Real_estate.vue?vue&type=template&id=4e346c38&scoped=true"
import script from "./Real_estate.vue?vue&type=script&lang=js"
export * from "./Real_estate.vue?vue&type=script&lang=js"

import "./Real_estate.vue?vue&type=style&index=0&id=4e346c38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e346c38"]])

export default __exports__